module.exports = __webpack_public_path__ + "img/novelty-shop.453c05f1.png";